import React from "react";
import "./appDialog.css";

export default function AppDialog({
  open,
  title,
  message,
  onClose,
  onNo,
  onYes,
  noText = "No",
  yesText = "Save",
  busy = false,
}) {
  if (!open) return null;

  return (
    <div className="appDlgOverlay" onMouseDown={onClose}>
      <div className="appDlg" onMouseDown={(e) => e.stopPropagation()}>
        <div className="appDlgHead">
          <div className="appDlgTitle">{title}</div>
          <button className="appDlgX" type="button" onClick={onClose} aria-label="Close">
            ✕
          </button>
        </div>

        <div className="appDlgBody">
          <div className="appDlgMsg">{message}</div>

          <div className="appDlgActions">
            <button className="appDlgBtn appDlgBtnNo" type="button" onClick={onNo} disabled={busy}>
              {noText}
            </button>
            <button className="appDlgBtn appDlgBtnYes" type="button" onClick={onYes} disabled={busy}>
              {busy ? "Saving..." : yesText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
